import type { TimeValidityType } from '../../../../models/time-validity-type.enum';
import type { TimeValidityUnit } from '../../../../models/time-validity-unit.enum';
import type { ITimeValidity } from '../../../../models/time-validity.model';
import { DateHelper } from '../../../../helpers/date.helper';

export class TimeValidityApiModel {
  public static mapToBusinessModel(apiModel: TimeValidityApiModel): ITimeValidity {
    return {
      type: apiModel.type,
      amount: apiModel.amount,
      unit: apiModel.unit,
      fromDate: DateHelper.parseWithFallback(apiModel.fromDate, undefined),
      toDate: DateHelper.parseWithFallback(apiModel.toDate, undefined),
      fromDateTime: DateHelper.parseWithFallback(apiModel.fromDateTime, undefined),
      toDateTime: DateHelper.parseWithFallback(apiModel.toDateTime, undefined),
    };
  }

  public type!: TimeValidityType;
  public amount?: number;
  public unit!: TimeValidityUnit;
  public fromDate?: string;
  public toDate?: string;
  public fromDateTime?: string;
  public toDateTime?: string;
}
